"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { item as drawerListItem, nodeMarker } from "../ui";
import geoStore from "../stores/geoStore";
import configStore from "../stores/configStore";
let maxZIndex = 0;
export default class GeoDatasourceNode {
  constructor({ node, map }) {
    this.data = node;
    this.map = map;
    this.marker = void 0;
  }
  get isFetched() {
    return true;
  }
  bringToFront() {
    if (!this.marker) return;
    this.marker.setZIndexOffset(maxZIndex += 100);
  }
  staledState() {
    var _a, _b, _c;
    if (this.marker.options.icon.options.className === "circle-marker") {
      const outerCircle = (_b = (_a = this.marker.getElement()) == null ? void 0 : _a.querySelector("svg circle[stroke]")) == null ? void 0 : _b.style;
      if (outerCircle) {
        outerCircle.stroke = "#000000";
        outerCircle.opacity = "0.64";
      }
    } else if (this.marker.options.icon.options.className === "arrow-marker") {
      const outerCircle = (_c = this.marker.getElement()) == null ? void 0 : _c.querySelector("#SVGRepo_bgCarrier rect[fill]");
      if (outerCircle) {
        outerCircle.setAttribute("fill", "#000000");
        outerCircle.setAttribute("opacity", "0.64");
      }
    }
  }
  selectedState() {
    var _a, _b, _c;
    if (this.marker.options.icon.options.className === "circle-marker") {
      const outerCircle = (_b = (_a = this.marker.getElement()) == null ? void 0 : _a.querySelector("svg circle[stroke]")) == null ? void 0 : _b.style;
      if (outerCircle) {
        outerCircle.stroke = "var(--primary)";
        outerCircle.opacity = "1";
      }
    } else if (this.marker.options.icon.options.className === "arrow-marker") {
      const outerCircle = (_c = this.marker.getElement()) == null ? void 0 : _c.querySelector("#SVGRepo_bgCarrier rect");
      if (outerCircle) {
        outerCircle.setAttribute("fill", "var(--primary)");
        outerCircle.setAttribute("opacity", "1");
      }
    }
  }
  isGeoLocated() {
    if (!this.marker) return false;
    let latlng = [];
    if (this.marker.getLatLng) {
      latlng = this.marker.getLatLng();
    } else if (this.marker.getLatLngs) {
      const points = this.marker.getLatLngs();
      latlng = Array.isArray(points) && points.length > 0 && points[0].length > 0 ? points[0][0] : null;
    }
    return (latlng == null ? void 0 : latlng.lat) && (latlng == null ? void 0 : latlng.lng);
  }
  repaint() {
    const { selectedPoint } = geoStore.getState();
    const { selected_component, defaultSelectedPoint: pinPoint } = configStore.getState();
    if (this.isGeoLocated()) {
      if (pinPoint) {
        if (selectedPoint && selectedPoint === this) {
          this.selectedState();
          this.bringToFront();
        } else if (!selectedPoint && `${this.data.componentId}` == `${selected_component}` && `${pinPoint}` === `${this.data.resourceId}`) {
          this.selectedState();
        } else {
          this.staledState();
        }
      } else {
        if (selectedPoint === this) {
          this.selectedState();
          this.bringToFront();
        } else if (!selectedPoint && `${this.data.componentId}` === `${selected_component}`) {
          this.selectedState();
        } else {
          this.staledState();
        }
      }
    }
  }
  colorLayers() {
    if (!this.isGeoLocated()) return;
    const { map } = configStore.getState();
    map.eachLayer((layer) => {
      if (layer.feature) {
        if (layer.feature.geometry.properties.id === this.geoScopeId) {
          layer.setStyle(this.selectedState);
        } else {
          layer.setStyle(this.staledState);
        }
      }
    });
  }
  get type() {
    if (!this.data.id || !this.data.resourceType) return void 0;
    return this.data.resourceType;
  }
  get resourceType() {
    return this.type;
  }
  get id() {
    return parseInt(`${this.data.id}`) || void 0;
  }
  get scopeId() {
    return parseInt(`${this.data.geoScopeId}`) || void 0;
  }
  get geoScopeId() {
    return this.scopeId;
  }
  panToMarker() {
    return __async(this, null, function* () {
      const { map_config: mapConfig } = configStore.getState();
      const { focus_zoom_level: focusZoomLevel = 21 } = mapConfig;
      if (!this.isGeoLocated()) return;
      const { map } = configStore.getState();
      return new Promise((resolve) => {
        map.flyTo(this.marker.getLatLng(), focusZoomLevel, {
          animate: false,
          noMoveStart: true
        }).once("moveend", () => {
          this.repaint();
          resolve();
        });
      });
    });
  }
  select() {
    geoStore.getState().selectPoint(this);
  }
  init() {
    var _a, _b, _c, _d;
    if (((_b = (_a = this.data) == null ? void 0 : _a.lonlat) == null ? void 0 : _b.latitude) && ((_d = (_c = this.data) == null ? void 0 : _c.lonlat) == null ? void 0 : _d.longitude)) {
      this.marker = nodeMarker(this.data);
      this.marker.on("click", this.select.bind(this));
      this.bringToFront();
    }
    try {
      this.repaint();
      this.menuItem = drawerListItem(this.data);
      this.menuItem.onclick = this.select.bind(this);
      geoStore.subscribe(
        (state) => [state.selectedPoint],
        (_np, [unselectedPoint]) => {
          if (unselectedPoint) {
            unselectedPoint.repaint();
          }
          this.repaint();
        }
      );
    } catch (error) {
      console.error("ERROR: decidim-geo can't initialize ", { error });
    }
    return this;
  }
}
